import { LOGIN_OR_JOIN_METHODS } from './constants';
import type { LoginOrJoinMethod, LoginOrJoinMethodShortcode } from './types';

export function getLoginOrJoinMethodShortcode(loginOrJoinMethod?: string): string | undefined {
	return Object.keys(LOGIN_OR_JOIN_METHODS).find(
		(key) => LOGIN_OR_JOIN_METHODS[key as LoginOrJoinMethodShortcode] === (loginOrJoinMethod as LoginOrJoinMethod),
	);
}
